import { createFileRoute, useRouter } from "@tanstack/react-router";
import { makeEncryptedPan } from "@/lib/utils";
import ContainerInset from "@/components/container-inset";
import PageLayoutRoot, {
  PageLayoutContent,
  PageLayoutHeader,
} from "@/components/page-layout";
import { useMerchantProvider } from "@/app/(authenticated)/_providers/merchant-provider";
import InvoiceForm from "./_components/invoice-form";

export const Route = createFileRoute(
  "/(authenticated)/$merchantId/invoices/add/"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();
  const { selectedMerchant } = useMerchantProvider();
  return (
    <ContainerInset
      title="Add Invoice"
      breadcrumbs={[
        {
          title: "Invoices",
          href: `/${selectedMerchant?.merchAccountId}/invoices`,
        },
        {
          title: "Add Invoice",
          href: "#",
        },
      ]}
    >
      <PageLayoutRoot>
        <PageLayoutHeader
          title="Create Invoice"
          description="This invoice includes several charges that remain unpaid. It reflects partial payments made, with the remaining balance still due."
        />

        <PageLayoutContent>
          <InvoiceForm
            onCreateSuccess={() => {
              router.history.back();
            }}
          />
        </PageLayoutContent>
      </PageLayoutRoot>
    </ContainerInset>
  );
}
